import get from './get';
import activity from './activity';

export default { get, activity };
